import { render, staticRenderFns } from "./MembresiasView.vue?vue&type=template&id=116ac0cd&scoped=true"
import script from "./MembresiasView.vue?vue&type=script&lang=js"
export * from "./MembresiasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116ac0cd",
  null
  
)

export default component.exports